;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { MdCheck } from 'react-icons/md';

function ProfileModalListItem({ text }: { text: string }) {
  return (
    <li className="position-relative mb-3">
      <MdCheck
        style={{
          top: 2,
          left: -40,
        }}
        size={24}
        className="d-inline-block position-absolute"
        color="#2ec4b6"
      />
      {text}
    </li>
  );
}

export default ProfileModalListItem;
